import { useState } from 'react'

const Field = ({ label, children }) => (
  <div className="form-group" style={{ margin: 0 }}>
    <label>{label}</label>
    {children}
  </div>
)

function QuestionForm({ editingQuestion, form, setForm, orgUsers, onSave, onCancel }) {
  const [activeTab, setActiveTab] = useState('details')
  const u = (field) => (e) => setForm(prev => ({ ...prev, [field]: e.target.value }))

  return (
    <div style={{ background: 'var(--white)', border: '1px solid var(--green-light)', padding: '24px', marginBottom: '24px', borderLeft: '4px solid var(--green)' }}>
      <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '1.25rem', fontWeight: 600, color: 'var(--green-dark)', marginBottom: '20px' }}>
        {editingQuestion ? `Edit Question ${editingQuestion.question_number}` : 'Add New Question'}
      </div>
      <div style={{ display: 'flex', gap: '4px', marginBottom: '20px', borderBottom: '2px solid var(--green-light)' }}>
        {['Details', 'Storyboard'].map(tab => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab.toLowerCase())}
            style={{
              padding: '8px 16px', border: 'none',
              background: activeTab === tab.toLowerCase() ? 'var(--green)' : 'none',
              color: activeTab === tab.toLowerCase() ? 'var(--white)' : 'var(--slate)',
              fontSize: '0.8125rem', fontWeight: 600, cursor: 'pointer'
            }}
          >
            {tab}
          </button>
        ))}
      </div>
      {activeTab === 'details' && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
          <Field label="Question Number *">
            <input type="text" value={form.question_number} onChange={u('question_number')} placeholder="e.g. Q4.2 or Section 3 Q1" />
          </Field>
          <Field label="Section (optional)">
            <input type="text" value={form.section} onChange={u('section')} placeholder="e.g. Technical, Commercial" />
          </Field>
          <Field label="Question Text *">
            <textarea value={form.question_text} onChange={u('question_text')} placeholder="Paste the full question text here" rows={3} style={{ gridColumn: '1 / -1' }} />
          </Field>
          <Field label="Evaluation Criteria">
            <textarea value={form.evaluation_criteria} onChange={u('evaluation_criteria')} placeholder="What will the evaluator be scoring against?" rows={2} />
          </Field>
          <Field label="Word Limit">
            <input type="number" value={form.word_limit} onChange={u('word_limit')} placeholder="e.g. 500" />
          </Field>
          <Field label="Page Limit">
            <input type="number" value={form.page_limit} onChange={u('page_limit')} placeholder="e.g. 2" />
          </Field>
          <Field label="Weighting (%)">
            <input type="number" value={form.weighting} onChange={u('weighting')} placeholder="e.g. 15" />
          </Field>
          <Field label="Assigned To">
            <select value={form.assigned_to} onChange={u('assigned_to')} style={{ width: '100%' }}>
              <option value="">Unassigned</option>
              {(orgUsers || []).map(u => (
                <option key={u.id} value={u.id}>{u.full_name || u.username}</option>
              ))}
            </select>
          </Field>
          <Field label="Status">
            <select value={form.status} onChange={u('status')} style={{ width: '100%' }}>
              <option value="not_started">Not Started</option>
              <option value="in_progress">In Progress</option>
              <option value="first_draft">First Draft</option>
              <option value="in_review">In Review</option>
              <option value="complete">Complete</option>
            </select>
          </Field>
          <Field label="Response Draft URL">
            <input type="text" value={form.response_url || ''} onChange={u('response_url')} placeholder="https://docs.google.com/..." />
          </Field>
          <Field label="Notes">
            <textarea value={form.notes} onChange={u('notes')} placeholder="Any additional notes" rows={2} />
          </Field>
        </div>
      )}
      {activeTab === 'storyboard' && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '16px' }}>
          <Field label="Win Theme">
            <input type="text" value={form.win_theme} onChange={u('win_theme')} placeholder="The specific win theme this response should demonstrate" />
          </Field>
          <Field label="Discriminators">
            <textarea value={form.discriminators} onChange={u('discriminators')} placeholder="What genuinely differentiates our answer to this question?" rows={3} />
          </Field>
          <Field label="Proof Points">
            <textarea value={form.proof_points} onChange={u('proof_points')} placeholder="Case studies, statistics, accreditations, and past performance evidence to use." rows={3} />
          </Field>
          <Field label="Response Structure">
            <textarea value={form.response_structure} onChange={u('response_structure')} placeholder="Para 1: Introduction&#10;Para 2: Approach&#10;Para 3: Evidence&#10;Para 4: Added value" rows={5} />
          </Field>
          <Field label="Compliance Notes">
            <textarea value={form.compliance_notes} onChange={u('compliance_notes')} placeholder="What must be addressed to avoid a compliance fail?" rows={2} />
          </Field>
          <Field label="Graphics Plan">
            <input type="text" value={form.graphics_plan} onChange={u('graphics_plan')} placeholder="e.g. Process diagram showing delivery methodology" />
          </Field>
        </div>
      )}
      <div className="actions" style={{ marginTop: '20px' }}>
        <button className="btn btn--primary" onClick={onSave} disabled={!form.question_number.trim() || !form.question_text.trim()}>
          {editingQuestion ? 'Save Changes' : 'Add Question'}
        </button>
        <button className="btn btn--secondary" onClick={onCancel}>Cancel</button>
      </div>
    </div>
  )
}

export default QuestionForm
